export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { duration: 1.5, offset: 0 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
